/*
 * @Description:
 */
import fetch from '../axios/fetch'
import store from '../../store'
import { checkBrowser, isPC } from '../channel/setUserChannel'
// import shareImgUrl from '../../assets/images/shareURLImg.png' // 分享的logo图片
const ENV = process.env.VUE_APP_NODE_ENV
const channel = checkBrowser()
// 分享图标
const IMGURL = 'https://ump.ems.com.cn/newmail-resources/images/logo/ems_share.png'
// 默认分享的链接
const linkEnv = {
  'production': 'https://ump.ems.com.cn/ndwz/r/bMJJri',
  'release': 'https://ump.ems.com.cn/ndwz/r/vMrU73',
  'development': 'https://ump.ems.com.cn/ndwz/r/vMrU73',
  'test': 'https://ump.ems.com.cn/ndwz/r/vMrU73'
}
// 默认分享的参数
const shareOption = { title: '美好轻松寄,更快更安全', desc: '点击查看, EMS全心全意为您提供寄递服务', link: linkEnv[ENV] }
// 必填，需要使用的JS接口列表
const jsApiList = [
  'scanQRCode', 'startRecord', 'stopRecord', 'playVoice', 'stopVoice',
  'uploadVoice', 'translateVoice', 'updateAppMessageShareData', 'updateTimelineShareData',
  'onMenuShareTimeline', 'onMenuShareAppMessage', 'checkJsApi', 'hideOptionMenu', 'getLocation'
]
// 状态回调函数
const stateCallBack = function (resolve, reject) {
  return {
    success: function (res) {
      console.log('分享:success')
      // 设置成功
      resolve(res)
    },
    cancel: function (res) {
      console.log('分享:cancel')
      reject(res)
    },
    fail: function (res) {
      console.log('分享:fail')
      reject(res)
    }
  }
}

// 重写分享方法，当有传入一个空对象置空分享参数时，可以设置默认分享参数
const _onMenuShareAppMessage = wx.onMenuShareAppMessage
const _onMenuShareTimeline = wx.onMenuShareTimeline
wx.onMenuShareAppMessage = function (option) {
  let { title = shareOption.title, desc = shareOption.desc, link = shareOption.link, imgUrl = IMGURL } = option
  let { success = () => {}, cancel = () => {}, fail = () => {} } = option
  _onMenuShareAppMessage({
    title: title, // 分享标题
    desc: desc, // 分享描述
    link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: imgUrl, // 分享图标
    success: success,
    cancel: cancel,
    fail: fail
  })
}
wx.onMenuShareTimeline = function (option) {
  let { title = shareOption.title, link = shareOption.link, imgUrl = IMGURL } = option
  let { success = () => {}, cancel = () => {}, fail = () => {} } = option
  _onMenuShareTimeline({
    title: title, // 分享标题
    link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: imgUrl, // 分享图标
    success: success,
    cancel: cancel,
    fail: fail
  })
}
// 获取微信jssdk配置参数
export const getWXConfigParams = async function (url = '') {
  if (channel !== 'WECHAT') {
    return false
  }
  let _url = url || location.href.split('#')[0]
  let { data } = await fetch.post('/getThirdParameters', {
    url: _url
  }, 'application/x-www-form-urlencoded;charset=UTF-8')
  if (data.code === '000000' && data.info) {
    let { appId = '', timestamp = '', nonceStr = '', signature = '' } = data.info.jsapi
    let signatureVerification = {
      appId: appId, // 必填，公众号的唯一标识
      timestamp: timestamp, // 必填，生成签名的时间戳
      nonceStr: nonceStr, // 必填，生成签名的随机串
      signature: signature, // 必填，签名
      jsApiList,
      openTagList: ['wx-open-launch-weapp']
    }
    store.dispatch('wxSignature/setSignatureVerification', signatureVerification)
    return signatureVerification
  }
}
// 设置微信jssdk配置参数，包括了请求配置参数
export const setWXConfigParams = async function () {
  let signatureVerification = store.state.wxSignature.signatureVerification
  let data = {}
  // 因为签名值都是一起请求赋值的，所以判断一个是否有值即可
  if (signatureVerification.signature) {
    data = signatureVerification
  } else {
    data = await getWXConfigParams()
  }
  if (isPC()) {
    wx.hideOptionMenu()
  }
  if (Object.keys(data).length > 0) {
    // 微信配置 调用
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      ...data
    })
  }
}
// 微信js的ready函数
// 微信js的ready函数
export const wxReady = function (callback) {
  wx.ready(() => {
    callback()
  })
}
// 微信的分享
export const onMenuShare = async function ({ title = '', desc = '', link = '', imgUrl = IMGURL }) {
  if (channel !== 'WECHAT') {
    return false
  }
  return new Promise(async (resolve, reject) => {
    // 需在用户可能点击分享按钮前就先调用
    wxReady(() => {
      wx.onMenuShareAppMessage({
        title: title, // 分享标题
        desc: desc, // 分享描述
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        ...stateCallBack(resolve, reject)
      })
      wx.onMenuShareTimeline({
        title: title, // 分享标题
        link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: imgUrl, // 分享图标
        ...stateCallBack(resolve, reject)
      })
    })
  })
}
// 默认分享
export const onMenuShareDefault = function () {
  onMenuShare(shareOption)
}
